import { AOQNNode, createTree } from "../AdvancedQuery";
import { combineRootPropertiesLists, calculateTopEightPropertiesList, processField, processValue, processOperator } from "../helpers";

function combineFilters(patientQuery, caseQuery, advancedQueryCriteria) {
    let relationalFilterLeafNodes = [];
    let mergedRelational = { ...patientQuery, ...caseQuery };
    let advancedQuery = {};
    for (let entry of Object.entries(mergedRelational)) {
        if (isObject(entry[1]) && entry[1].to) {
            // this means we're now processing Case.PatientAgeAtCaseStartInYears
            let field = processField(entry[0]);

            // from
            let value = processValue(entry[0], entry[1].from);
            relationalFilterLeafNodes.push(new AOQNNode(">=", undefined, undefined, field, value));

            // to
            value = processValue(entry[0], entry[1].to);
            relationalFilterLeafNodes.push(new AOQNNode("<=", undefined, undefined, field, value));
        }
        else {

            let field = processField(entry[0]);
            let value = processValue(entry[0], entry[1]);
            let operator = processOperator(entry[0]);

            relationalFilterLeafNodes.push(new AOQNNode(operator, undefined, undefined, field, value));
        }
    }

    advancedQuery.Relational = createTree(relationalFilterLeafNodes);

    if (Object.keys(advancedQueryCriteria.MrAttributes).length > 0)
        advancedQuery.MrAttributes = advancedQueryCriteria.MrAttributes;
    else advancedQuery.MrAttributes = null;

    return cleanFilters(advancedQuery);
}

function cleanFilters(filters) {
    let cleanedUpFilters = {};

    if (filters.MrAttributes && Object.keys(filters.MrAttributes).length > 0)
        cleanedUpFilters.MrAttributes = filters.MrAttributes;
    else cleanedUpFilters.MrAttributes = null;

    if (filters.Relational && Object.keys(filters.Relational).length > 0)
        cleanedUpFilters.Relational = filters.Relational;
    else cleanedUpFilters.Relational = null;

    return cleanedUpFilters;
}

function isObject(input) {
    return typeof input === 'object' && input !== null;
}

const calculateTopEightBarCharts = (barChartFields, loadedStatistics) => {
    barChartFields.forEach((element) => {
        if (element.calculateTopEight) {
            let resultPath = loadedStatistics;
            const pathLastIndex = element.path.length - 1;
            for (let index = 0; index < element.path.length - 1; index++) {
                resultPath = resultPath[element.path[index]];
            }
            resultPath[element.path[pathLastIndex]] = calculateTopEightPropertiesList(resultPath[element.path[pathLastIndex]]);
        }
    });
};

const combineNationalDataForBarCharts = (barChartFields, loadedStatistics, nationalStatistics) => {
    barChartFields.forEach((element) => {
        let nationalPath = nationalStatistics;
        let resultPath = loadedStatistics;
        const pathLastIndex = element.path.length - 1;

        for (let index = 0; index < pathLastIndex; index++) {
            nationalPath = nationalPath[element.path[index]];
            resultPath = resultPath[element.path[index]];
        }

        nationalPath = nationalPath[element.path[pathLastIndex]];

        if (nationalPath.mrAttributeRowViewModelList.length > 0)
            resultPath[element.path[pathLastIndex]] = combineRootPropertiesLists(
                resultPath[element.path[pathLastIndex]],
                nationalPath,
            );
    });
}

export { combineFilters, calculateTopEightBarCharts, combineNationalDataForBarCharts };
